// extracted by mini-css-extract-plugin
module.exports = {"highlightOptions":"style__highlightOptions__U5-FF","lessonInModalTooltip":"style__lessonInModalTooltip__-X0zb"};